import { IdlePeriodSettingsProxy } from 'src/Libs/smart-charge/types'
import { EmsIdlePeriodsSection } from 'src/Libs/smart-charge/components/index'
import {
  IdlePeriodLegacySettingsFormModel,
  IdlePeriodLegacySettingsModel,
  IdlePeriodSettingsFormModel,
  IdlePeriodSettingsModel,
} from 'src/Libs/smart-charge/models'
import React from 'react'
import EmsIdlePeriodsLegacySection from 'src/Libs/smart-charge/components/EmsIdlePeriodsLegacySection'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

interface Props {
  value: IdlePeriodSettingsProxy | null
  onUpdateDefault: (values: IdlePeriodSettingsFormModel) => Promise<void>
  onUpdateLegacy: (values: IdlePeriodLegacySettingsFormModel) => Promise<void>
  hasWritingRights?: boolean
}

const IdlePeriodSettingsDispatch: React.FC<Props> = ({ value, onUpdateDefault, onUpdateLegacy, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()

  if (!value) {
    return (
      <AccordionItem title={t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.sectionTitle')}>
        <SystemSettingsBlankView />
      </AccordionItem>
    )
  }

  if (value.isLegacy) {
    return (
      <EmsIdlePeriodsLegacySection
        model={value.value as IdlePeriodLegacySettingsModel}
        onChange={onUpdateLegacy}
        hasWritingRights={hasWritingRights}
      />
    )
  }
  return <EmsIdlePeriodsSection model={value.value as IdlePeriodSettingsModel} onChange={onUpdateDefault} hasWritingRights={hasWritingRights} />
}

export default IdlePeriodSettingsDispatch
